/**
 * KWC · Keep the card's variant thumbnails alive across a swatch selection.
 *
 * THE BUG THIS FIXES
 * Clicking a thumbnail made the thumbnails vanish, native colour swatches appear
 * for a moment, and the add-to-cart button go disabled.
 *
 * Horizon's SwatchesVariantPickerComponent does not update the card in place —
 * it re-fetches the card from the server and morphs the response in. The section
 * it asks for is chosen in variant-picker.js by SECTION_ID_MAP, which matches on
 * the element name `swatches-variant-picker-component`. Our picker uses that same
 * element (it has to: product-card.js hard-codes
 * `querySelector('swatches-variant-picker-component')` to find the picker, read
 * the selected media id and toggle the buy button). So the fetch returned
 * `section-rendering-product-card`, which renders Horizon's native
 * `variant-swatches` snippet — and the morph replaced our image thumbnails with
 * that native markup.
 *
 * THE FIX
 * Point only *our* pickers at `sections/kwc-card-rendering.liquid`, a twin of
 * that section that renders `kwc-card-variants` instead. The response then
 * matches what is already on the page, so the morph is a no-op on structure and
 * only the selected state, price and media ids change — which is exactly what
 * the native flow does for a native card.
 *
 * This patches one method on the registered class rather than subclassing,
 * because the element name cannot change without breaking product-card.js.
 * Pickers without data-kwc-card are untouched, so the homepage cards and
 * quick-add keep Horizon's behaviour exactly.
 */

const PICKER_TAG = 'swatches-variant-picker-component';
const NATIVE_SECTION = 'section_id=section-rendering-product-card';
const KWC_SECTION = 'section_id=kwc-card-rendering';

customElements.whenDefined(PICKER_TAG).then(() => {
  const PickerComponent = customElements.get(PICKER_TAG);

  // Guard against double-patching if this module is ever loaded twice.
  if (!PickerComponent || PickerComponent.prototype.kwcCardSectionPatched) return;

  const originalBuildRequestUrl = PickerComponent.prototype.buildRequestUrl;
  if (typeof originalBuildRequestUrl !== 'function') return;

  /**
   * Defers entirely to Horizon's own URL construction and only swaps the
   * section id, so any future change to how that URL is built is inherited.
   * @param {...any} args - Forwarded to the original implementation.
   * @returns {string} The request URL.
   */
  PickerComponent.prototype.buildRequestUrl = function (...args) {
    const requestUrl = originalBuildRequestUrl.apply(this, args);

    if (this.dataset.kwcCard !== 'true' || typeof requestUrl !== 'string') return requestUrl;

    return requestUrl.replace(NATIVE_SECTION, KWC_SECTION);
  };

  PickerComponent.prototype.kwcCardSectionPatched = true;
});
